import React, { useState, useEffect } from 'react';
import { Users, Eye } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const VisitorCounter = () => {
  const [stats, setStats] = useState({ total_visitors: 0, today_visitors: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const trackAndFetch = async () => {
      try {
        const sessionKey = 'visitor_tracked';
        const alreadyTracked = sessionStorage.getItem(sessionKey);
        if (!alreadyTracked) {
          await axios.post(`${API_URL}/api/visitors/track`);
          sessionStorage.setItem(sessionKey, 'true');
        }
        const response = await axios.get(`${API_URL}/api/visitors/count`);
        setStats(response.data);
      } catch (error) {
        console.error('Error with visitor counter:', error);
      } finally {
        setLoading(false);
      }
    };
    trackAndFetch();
  }, []);

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toLocaleString();
  };

  if (loading) return null;

  return (
    <div className="fixed bottom-24 left-6 z-40 bg-[#f3ede0]/95 backdrop-blur-md rounded-xl shadow-lg border border-[#e6dfd0] p-4 flex items-center gap-4" data-testid="visitor-counter">
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-gold-400/10 rounded-full flex items-center justify-center">
          <Eye className="w-5 h-5 text-gold-400" />
        </div>
        <div>
          <p className="text-xs text-[#8b94a3] font-medium">Total Visitors</p>
          <p className="text-lg font-bold text-gold-400" data-testid="total-visitors">{formatNumber(stats.total_visitors)}</p>
        </div>
      </div>
      <div className="h-10 w-px bg-[#e6dfd0]" />
      <div className="flex items-center gap-2">
        <div className="w-10 h-10 bg-green-900/30 rounded-full flex items-center justify-center">
          <Users className="w-5 h-5 text-green-400" />
        </div>
        <div>
          <p className="text-xs text-[#8b94a3] font-medium">Today</p>
          <p className="text-lg font-bold text-green-400" data-testid="today-visitors">{formatNumber(stats.today_visitors)}</p>
        </div>
      </div>
    </div>
  );
};

export default VisitorCounter;
